export function initCustomFieldsTagsInput() {
    $('.custom-field-multiselect').each(function(index, element) {
      const isInitiated = $(element).attr('is-initiated');

      if (isInitiated) {
        return;
      }

      $(element).attr('is-initiated', true);
      $(element).attr('multiple', 'multiple');
      $(element).removeClass('custom-select')

      const prevElement = $(element).prev('.temprorary-select');
      if (prevElement[0]) prevElement[0].classList.add('d-none');

      let placeholderText = $(element).data('placeholder');
      $(element).selectpicker({
        noneSelectedText: placeholderText,
      });

      let parentElement = $(element).parent('.bootstrap-select');
      let valueHolderElement = $(parentElement).find('.filter-option-inner-inner');

      if(!$(element).val().length) {
        $(valueHolderElement).addClass('empty-value')
      }

      $(element).on('changed.bs.select', function (e) {
        if (e.target.value === '') {
          $(valueHolderElement).addClass('empty-value')
        } else {
          $(valueHolderElement).removeClass('empty-value')
        }
      });

      // Add event listener for Enter or Space to toggle the dropdown
      $(parentElement).on('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault(); // Prevent default behavior

          if (!$(parentElement).hasClass('show')) {
            $(element).selectpicker('toggle'); // Open the dropdown if it's closed
          }
        }
      });
    });
}

$(function () {
  initCustomFieldsTagsInput();

  document.addEventListener('jb.section.rendered', () => {
    initCustomFieldsTagsInput();
  });
});

/**
 *
 * @param customFields
 * @returns {{}}
 */
export function setCustomFieldsData(customFields, globalCustomFormsKey) {
  customFields = cleanupCustomFields(customFields);

  const customFieldsForCurrentForm = window.$customFields[globalCustomFormsKey];

  const customMultiselectFields = customFieldsForCurrentForm.filter($customFields => $customFields.field_type === "multi_select");
  const customMultiselectFieldIds = customMultiselectFields.map(customMultiselectField => customMultiselectField.id)

  const customCheckboxFields = customFieldsForCurrentForm.filter($customFields => $customFields.field_type === "checkbox");
  const customCheckboxFieldIds = customCheckboxFields.map(customCheckboxField => customCheckboxField.id)

  const customSkillsFields = customFieldsForCurrentForm.filter($customFields => $customFields.field_type === "skills");
  const customSkillsFieldIds = customSkillsFields.map(customSkillField => customSkillField.id)

  const customImageGalleryFields = customFieldsForCurrentForm.filter($customFields => $customFields.field_type === "image_gallery");
  const customImageGalleryFieldIds = customImageGalleryFields.map(customImageGalleryField => customImageGalleryField.id)

  customCheckboxFieldIds.forEach(id => {
    customFields[id].value = customFields[id].value && customFields[id].value !== '' ? true : false;
  })
  customMultiselectFieldIds.forEach(id => {
    if (!customFields[id].value) {
      customFields[id].value = [];
    }
  })

  customSkillsFieldIds.forEach(id => {
    if (customFields[id].value) {
      customFields[id].value = cleanupCustomFields(customFields[id].value)
    } else {
      customFields[id].value = {};
    }
  })

  customImageGalleryFieldIds.forEach(id => {
    const value = customFields[id].value;
    if (typeof value === 'string') {
      try {
        customFields[id].value = JSON.parse(value);
      } catch (_) {
        customFields[id].value = [];
      }
    }

    if (!Array.isArray(customFields[id].value)) {
      customFields[id].value = [];
    }
  })

  return customFields
}

/**
 *
 * @param obj
 * @returns {{}}
 */
const cleanupCustomFields = function (obj) {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce(
      (acc, [k, v]) => ({...acc, [k]: v}),
      {}
    );
}
